import { Component, h, Prop, State, Element, Host } from "@stencil/core"
import {
  selectReducer,
  getInitialState,
  SelectState,
  SelectActions,
} from "../select-store"
import {
  StoreConnection,
  StateHandle,
  computedProperty,
  getAppearance,
} from "../../../core/helpers/webcomponent-helpers"

@Component({
  tag: "sdx-select-optgroup",
  styleUrl: "select-optgroup.scss",
  shadow: true,
})
export class SelectOptGroup {
  private store: StoreConnection<this, SelectState, SelectActions>

  @Element() public el!: HTMLSdxSelectOptgroupElement

  @State() public state!: StateHandle<SelectState>

  /**
   * Label of the group to be displayed.
   */
  @Prop() public name: string = ""

  constructor() {
    this.store = new StoreConnection(this, selectReducer, getInitialState(), [
      "directionX",
      "directionY",
      "filter",
    ])
  }

  public connectedCallback() {
    // Don't do anything while the component is being reappended (maybe
    // because it's being appended to document.body), but send a "ping" for
    // each child (sdx-select-optgroup).
    // After each child is has finished, "reappending" will be marked "done" by
    // the store.
    if (this.state.get().reappending) {
      this.store?.dispatch({ type: "UPDATE_REAPPENDING" })
      return
    }

    // Register self
    this.store.dispatch({
      type: "ADD_OPTGROUP_EL",
      optgroupEl: this.el,
    })
  }

  public disconnectedCallback() {
    // See connectedCallback() for explanation
    if (this.state.get().reappending) {
      return
    }

    // Unregister self
    this.store.dispatch({
      type: "REMOVE_OPTGROUP_EL",
      optgroupEl: this.el,
    })
  }

  public componentDidLoad() {
    this.store.subscribe()
  }

  private getHostClassNames() {
    const { isInsideDialog } = this.state.get()

    return {
      "inside-dialog": isInsideDialog,
    }
  }

  private getComponentClassNames() {
    return {
      ...computedProperty(this.state.get().directionY),
      component: true,
      [getAppearance(this.el)]: true,
    }
  }

  public render() {
    return (
      <Host class={this.getHostClassNames()}>
        <div class={this.getComponentClassNames()}>
          {this.name && <div class="name">{this.name}</div>}

          <slot />
        </div>
      </Host>
    )
  }
}
